<template>
	<el-dialog width="370px" :visible.sync="innerVisible" :before-close="closeDialog" append-to-body custom-class="newdialog" >
		<div class="innerdialog">
			<div class="innerdialog_list">
				<p>状态：</p>
				<div class="list_openclose">
					<p @click="openline = false,status = 0" :class="!openline?'tabOFF':''"
						style="border-radius: 4px 0 0 4px;">
					</p>
					<p @click="openline = true,status = 1" :class="openline?'tabActive':''"
						style="border-radius:  0 4px 4px 0;">
						<span v-if="openline">ON</span>
						<span v-else>OFF</span>
					</p>
				</div>
			</div>
			<div class="innerdialog_list">
				<p>姓名：</p>
				<el-input v-model="inputName" placeholder="请输入内容"></el-input>
			</div>
			<div class="innerdialog_list">
				<p>手机号：</p>
				<el-input v-model="inputPhone" type="number" oninput="if(value.length>11) value = value.slice(0,11)" placeholder="请输入内容"></el-input>
			</div>
			<div class="innerdialog_list">
				<p>默认密码：</p>
				<el-input v-model="inputPassword" :disabled="true" placeholder="请输入内容"></el-input>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeDialog">取 消</el-button>
			<el-button type="primary" @click="submitAdd">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {
		setSecondUser,
	} from '../../../api/moudles/application.js'
	import {vaildte} from '../../../utils/validate.js'

	export default {
		data() {
			return {
				inputName: '',
				inputPhone: '',
				inputCode: '',
				inputPassword: '123@A9',
				status: 1,
				openline: true,
				innerVisible: false,
				projectCode: '',
			}
		},
		methods: {
			closeDialog(){
				this.innerVisible = false
				this.inputName = ""
				this.inputPhone = ""
			},
			showDialog(code) {
				this.innerVisible = true
				this.projectCode = code
			},
			// 新增确定
			submitAdd() {
				const params = {
					username: this.inputName.trim(),
					cellphone: this.inputPhone.trim(),
					status: this.status,
					project_code: this.projectCode
				}
				if(!params.username){
					this.$message.error('姓名未填写')
					return
				}
				if(!params.cellphone){
					this.$message.error('手机号未填写')
					return
				}
				if(!vaildte.isPhone(params.cellphone)){
					this.$message.error('手机号填写不正确')
					return
				}
				setSecondUser({
					data: params,
					success: (res) => {
						console.log(res)
						const {
							msg,
							code
						} = res
						if (code === 200) {
							this.$message({
								message: msg,
								type: 'success'
							});
							this.innerVisible = false
							this.$emit('refresh')
							this.inputName = ""
							this.inputPhone = ""
						} else {
							this.$message.error(msg)
						}
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	>>>.newdialog {
		border-radius: 6px;
	}

	>>>.el-dialog__body {
		padding: 20px 20px 10px 20px;
	}

	.tabActive {
		background: #158AED;
		color: white !important;
	}

	.tabOFF {
		background-color: #DBDBDB;
	}

	.innerdialog {}

	.innerdialog_list {
		display: flex;
		height: 40px;
		margin: 10px 0;
	}

	.innerdialog_list p {
		display: inline-block;
		width: 110px;
		text-align: right;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
	}

	.list_openclose {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.list_openclose p {
		width: 50px;
		height: 34px;
		line-height: 34px;
		text-align: center;
		box-sizing: border-box;
	}

	.list_openclose:first-child p {
		border-radius: 4px 0 0 4px;
		border: 1px solid #DBDBDB;
	}

	.list_openclose:last-child p {
		border-radius: 0 4px 4px 0;
		border: 1px solid #DBDBDB;
	}
	
	/* 取消element ui input基础样式 */
	>>>input::-webkit-outer-spin-button,
	>>>input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	
	>>>input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
